export interface OnboardingFormData {
  firstName: string;
  lastName: string;
  title: string;
  preferredLocale: string;
  yearsExperience?: string;  // "<1" | "1-3" | "4-5" | ">5"
  percentTimeOnChangeManagement?: string;  // "0-25" | "26-50" | "51-75" | "76-100"
  currentChangeManagementCompetency?: string;  // "Novice" | "Advanced Beginner" | "Competent" | "Proficient" | "Expert"
  profileLastUpdated?: string;
}

// Unified option format:
// - value: what gets saved to the database
// - label: fallback display text
// - copyKey: key for Contentful lookup
export const YEARS_EXPERIENCE_OPTIONS = [
  { value: '<1', label: '<1 year', copyKey: 'lessThanOne' },
  { value: '1-3', label: '1-3 years', copyKey: 'oneToThree' },
  { value: '4-5', label: '4-5 years', copyKey: 'fourToFive' },
  { value: '>5', label: '>5 years', copyKey: 'moreThanFive' }
];

export const PERCENT_TIME_OPTIONS = [
  { value: '0-25', label: '0-25%', copyKey: 'zeroToTwentyFive' },
  { value: '26-50', label: '26-50%', copyKey: 'twentySixToFifty' },
  { value: '51-75', label: '51-75%', copyKey: 'fiftyOneToSeventyFive' },
  { value: '76-100', label: '76-100%', copyKey: 'seventySixToOneHundred' }
];

export const COMPETENCY_OPTIONS = [
  { value: 'Novice', label: 'Novice', copyKey: 'novice' },
  { value: 'Advanced Beginner', label: 'Advanced Beginner', copyKey: 'advancedBeginner' },
  { value: 'Competent', label: 'Competent', copyKey: 'competent' },
  { value: 'Proficient', label: 'Proficient', copyKey: 'proficient' },
  { value: 'Expert', label: 'Expert', copyKey: 'expert' }
];

export const LOCALE_OPTIONS = [
  { value: 'en-US', label: 'English (US)', copyKey: 'enUS' },
  { value: 'fr', label: 'Français', copyKey: 'fr' },
  { value: 'de', label: 'Deutsch', copyKey: 'de' },
  { value: 'pt', label: 'Português', copyKey: 'pt' },
  { value: 'es', label: 'Español', copyKey: 'es' },
  { value: 'zh-Hans', label: '简体中文', copyKey: 'zhHans' },
  { value: 'ja', label: '日本語', copyKey: 'ja' },
  { value: 'pl', label: 'Polski', copyKey: 'pl' }
];
